import shopifyEnterpriseGenericDefaults from '../shopify-enterprise-generic/config.js';

const baseFitmentFields = shopifyEnterpriseGenericDefaults.fitmentSearch.baseFields;

export default {
  ...shopifyEnterpriseGenericDefaults,
  includes: ['shopify-enterprise-generic'],
  Widgets: [
    ...shopifyEnterpriseGenericDefaults.Widgets.filter((w) => !['SearchVehicleWidget'].includes(w.name)),
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
      initCollapsed: true,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      columnBreakpoint: 705,
    },
  ],
};
